const navigateToSchemeWithFallback = (scheme, fallback, timeout = 2400) => {
  // if the page navigate failed, then fall back to download
  const timer = setTimeout(() => fallback(), timeout)

  const clearTimer = () => {
    clearTimeout(timer)
    document.removeEventListener('visibilitychange', clearTimer)
  }
  document.addEventListener('visibilitychange', clearTimer)
  document.location.href = scheme
}

export {
  navigateToSchemeWithFallback
}